import { useState } from 'react';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import Link from 'next/link';
import { Headercontent, ModalMenuBlog, NoHeadeMenu } from './header.styles';
import {
  Logo,
  LogoBlog,
  LogoBlogMob,
  Atsign,
  Backarrow,
  MenuIcon,
  LogoMartins
} from '@assets/svgs';
import Modal from '@components/Modal';
import Menu from '@components/Menu/index';

type HeaderProps = {
  onClick?: () => void;
  showBackButton?: boolean;
  showLogo?: boolean;
  showLogoBlog?: boolean;
  showLogoBlogMob?: boolean;
  showMenu?: boolean;
  color?: string;
  animationHeader?: string;
  logo?: any;
  email?: string;
  whatAppmsg?: string;
  whatAppLink?: string;
  showNoheader?: boolean;
  showCopyheader?: boolean;
  showTheStoryHeader?: boolean;
  showDanielllogo?: boolean;
};

const Header = ({
  onClick,
  showBackButton,
  showLogo,
  color,
  animationHeader,
  logo,
  showLogoBlog,
  showLogoBlogMob,
  showMenu,
  email,
  whatAppmsg,
  whatAppLink,
  showNoheader,
  showCopyheader,
  showTheStoryHeader,
  showDanielllogo
}: HeaderProps) => {
  const [isOpen, setIsopen] = useState(false);
  const [isMenu, setIsmenu] = useState(false);
  const [isMenuCopyw, setIsmenuCopyw] = useState(false);
  const [isMenuC, setIsmenuC] = useState(false);
  const [isAbout, setIsabout] = useState(false);
  const [isModalopen, setIsmodalopen] = useState(false);
  const router = useRouter();

  return (
    <>
      {showNoheader && (
        <Headercontent className={animationHeader}>
          {showMenu && (
            <MenuIcon
              animation="menuIcon"
              isActive={() => setIsmenu(!isMenu)}
            />
          )}
          {showBackButton && (
            <Backarrow
              animation="backButton"
              color={color}
              isActive={() => router.back()}
            />
          )}
          {/* <Atsign
            animation="atSign"
            color={color}
            isActive={() => setIsopen(true)}
          /> */}
          {!showLogoBlog && (
            <LogoMartins
              width={200}
              height={80}
              color="#000"
              animation="logo"
            />
          )}
          <span className="about" onClick={() => setIsabout(true)}>
            ABOUT
          </span>
          <span className="about" onClick={() => setIsopen(true)}>
            CONTACT US
          </span>
          {/* <span className="about" onClick={() => setIsmodalopen(true)}>
            Subscribe
          </span> */}
        </Headercontent>
      )}

      {showCopyheader && (
        <Headercontent className={animationHeader}>
          {showMenu && (
            <MenuIcon
              animation="menuIcon"
              isActive={() => setIsmenuCopyw(!isMenuCopyw)}
            />
          )}
          {/* <Atsign
            animation="atSign"
            color={color}
            isActive={() => setIsopen(true)}
          /> */}
          {!showLogoBlog && (
            <LogoMartins width={55} height={50} color="#000" animation="logo" />
          )}
          {/* <span className="about" onClick={() => setIsabout(true)}>
            ABOUT
          </span> */}
          <span className="about" onClick={() => setIsopen(true)}>
            CONTACTS
          </span>
          {/* <Link className="about" href="/blog/presentation">
            <span>Our Business</span>
          </Link> */}
          {/* <span className="about" onClick={() => setIsmodalopen(true)}>
            Subscribe
          </span> */}
          {/* <Link
            className="about"
            href="https://medium.com/@martinswriters"
            target="_blank"
          >
            <span>Blog</span>
          </Link> */}
          {/* <Link className="telf" href="tel:+447502816932">
            <span>+447502816932</span>
          </Link> */}
        </Headercontent>
      )}

      {showTheStoryHeader && (
        <NoHeadeMenu>
          {showMenu && (
            <MenuIcon
              animation="menuIconNoheader"
              isActive={() => setIsmenuC(!isMenuC)}
            />
          )}
        </NoHeadeMenu>
      )}
      {isOpen && (
        <Modal
          onClose={() => setIsopen(false)}
          contactModal
          logo={logo}
          email={'george.martins@jorgedd.com'}
          whatAppmsg={whatAppmsg}
          whatAppLink={whatAppLink}
        />
      )}

      {isMenu && (
        <ModalMenuBlog>
          <Menu showBaileysMenu />
        </ModalMenuBlog>
      )}
      {isMenuCopyw && (
        <ModalMenuBlog>
          <Menu showCopywritingMenu />
        </ModalMenuBlog>
      )}
      {isMenuC && (
        <ModalMenuBlog>
          <Menu showBaileysMenu showTheStory />
        </ModalMenuBlog>
      )}
      {isAbout && <Modal onClose={() => setIsabout(false)} aboutModal />}
      {isModalopen && (
        <Modal
          newsModal
          subscribeText="Martin's House"
          addStyle="1px solid #eee"
          onClose={() => setIsmodalopen(false)}
        />
      )}
    </>
  );
};

export default Header;
